import type { ReactElement } from 'react';

import { Icons } from '../../../icons/iconNames';
import { GameButtonWithTooltip, type GameButtonProps } from '../../gameButton/gameButton';

export interface BetOnAllControlProps extends Omit<GameButtonProps, 'icon'> {
  tooltip?: string;
}

export const BetOnAllControl = ({ disabled, tooltip, ...rest }: BetOnAllControlProps): ReactElement => (
  <GameButtonWithTooltip
    data-testid="bet-on-all-button"
    border
    disabled={disabled}
    grow
    icon={Icons.BetOnAll}
    sound="betOnAll"
    tooltipOptions={{
      disabled: disabled,
      text: tooltip || 'BETONALL',
    }}
    {...rest}
  />
);
